import {Base} from "@/api/Base"

export class RoleAdd extends Base {
    path = "role/add"
}